<template>
  <main>
    <div
      v-if="success"
      class="w-full h-full fixed bg-black/50 inset-0 z-50 flex justify-center items-center"
    >
      <div class="bg-white rounded p-4 shadow-sm max-w-sm w-full">
        <p class="font-bold !text-xl text-center py-4">
          Email de suivi envoyé avec succés
        </p>
        <p>
          Un email contenant votre lien de suivi viens de vous être envoyé par
          email
        </p>
        <p class="w-full text-center my-4">
          <router-link to="/"
            ><button class="text-base uppercase">Retour</button></router-link
          >
        </p>
      </div>
    </div>
    <form @submit.prevent="sendMail">
      <div class="max-w-xl m-auto text-center mt-12">
        <h2 class="font-bold text-2xl mb-4 uppercase text-[#ED6C23]">
          Suivi de ma participation
        </h2>
        <p class="!text-base">
          Merci de sélectioner l'offre concernée puis renseigner l'adresse email
          avec laquelle vous avez participé. Un email contenant le lien de suivi
          vous sera envoyé.
        </p>
        <p class="text-left">
          <label class="uppercase">Offres</label>
          <select @change="checkOp" v-model="operation" class="input">
            <option value="0"></option>
            <template v-for="op in results">
              <option :key="op._id" :value="op._id">{{ op.title }}</option>
            </template>
          </select>
          <span v-if="errorAskOp" class="error-suivi">{{ errorAskOp }}</span>
        </p>
        <p class="text-left mb-4">
          <label class="uppercase">Adresse e-mail</label>
          <input
            v-model="email"
            type="email"
            class="input"
            placeholder="Adresse email"
          />
          <span v-if="errorAskEmail" class="error-suivi">{{
            errorAskEmail
          }}</span>
        </p>
        <p>
          <button type="submit" class="button text-base uppercase">
            Envoyer
          </button>
        </p>
      </div>
    </form>
  </main>
</template>
<style>
.error-suivi {
  @apply bg-red-100 text-red-700 text-sm p-1 mt-1 rounded w-full block;
  color: red;
}
</style>
<script setup lang="ts">
import { ref } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/fr";

const operationsId = [
  {
    _id: "68760d9231332264387c136e",
  },
  {
    _id: "68907ff8b745780eb4643fe1",
  },
  {
    _id: "6939885452a281612e7ea5c5",
  },
  {
    _id: "693989b9a310d81c44e73407",
  },
  {
    _id: "696fa1e827dd902d7e2e459d",
  },
];

const results = ref([]);
const email = ref(undefined);
const operation = ref("0");
const errorAskEmail = ref(undefined);
const errorAskOp = ref(undefined);
const success = ref(false);

const checkOp = () => {
  errorAskOp.value = undefined;
};

const sendMail = async () => {
  try {
    if (operation.value == "0") {
      errorAskOp.value = "Merci de sélectionner une offre";
      return;
    }

    if (!email.value) {
      errorAskEmail.value = "Adresse email obligatoire";
      return;
    }

    const formDatas = {
      operationId: operation.value,
      email: email.value,
      lang: "fr",
    };

    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/operations-custom/promodev-send-contact/getlinkstatus`,
      {
        method: "POST",
        body: JSON.stringify(formDatas),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      success.value = true;
    } else {
      errorAskEmail.value = "Erreur lors de l'envoi de l'email";
    }
  } catch (e) {
    console.error("Erreur lors de l'envoi de l'email", e);
    errorAskEmail.value = "Erreur lors de l'envoi de l'email";
  }
};

const fetchOperation = async (_id) => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/v2/formdata/${_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    const modifiedData = transformData(data);
    return modifiedData;
  } catch (error) {
    console.error(`Erreur lors de la requête pour l'ID ${_id}:`, error);
    throw error;
  }
};

const isDateBetween = (startDate, endDate) => {
  const todayStart = dayjs().startOf('day');
  const todayEnd = dayjs().endOf('day');
  const start = dayjs(startDate, "DD/MM/YYYY").startOf('day');
  const end = dayjs(endDate, "DD/MM/YYYY").endOf('day');

  return !todayStart.isBefore(start) && !todayEnd.isAfter(end);
};

const transformData = (data) => {
  data.title = data.title.includes(" - ") ? data.title.split(" - ")[1] : data.title;
  data.date_debut = dayjs(data.date_debut).locale("fr").format("DD/MM/YYYY");
  data.date_fin = dayjs(data.date_fin).locale("fr").format("DD/MM/YYYY");

  const isActive = isDateBetween(data.date_debut, data.date_fin);
  data.isActive = isActive;

  return data;
};

const fetchAllOperations = async () => {
  try {
    const promises = operationsId.map((op) => fetchOperation(op._id));
    const results = await Promise.all(promises);
    
    // Filtrer uniquement les opérations actives
    return results.filter((op) => op.isActive);
  } catch (error) {
    console.error("Erreur lors du traitement des opérations:", error);
    throw error;
  }
};

fetchAllOperations()
  .then((fetchedResults) => {
    results.value = fetchedResults;
  })
  .catch((error) => {
    console.error("Une erreur est survenue:", error);
  });
</script>
